import { Map, OrderedMap, Record } from "immutable";

import { Course } from "seneca-common/features/course/state";
import { CrudBuilderState } from "seneca-common/utils/apiStates";

import coursesQueryMetaInitialState from "./CoursesQueryMeta";

export type CoursesState = OrderedMap<string, Course>;
export type AggregationsState = Map<string, number>;

export type CoursesQueryType = {
  courses: CoursesState;
  aggregations: AggregationsState;
  meta: CrudBuilderState | Map<any, any>;
};

const defaultCoursesQuery: CoursesQueryType = {
  courses: Map<string, Course>(),
  aggregations: Map<string, number>(),
  meta: coursesQueryMetaInitialState
};

export default class CoursesQuery extends Record(defaultCoursesQuery) {}
